import React from "react";
import {Menu} from "antd";

const clientInfo = [
    {
        title: 'E-mail Link',
        href: 'mailto:?',
        menuItem: 'Desktop email client',
        subjectParam: 'subject'
    },
    {
        title: 'Gmail Link',
        href: 'https://mail.google.com/mail/?view=cm&fs=1&',
        menuItem: 'Gmail',
        subjectParam: 'su'
    },
    {
        title: 'Yahoo Link',
        href: 'http://compose.mail.yahoo.com/?',
        menuItem: 'Yahoo',
        subjectParam: 'subj'
    },
    {
        title: 'Outlook Link',
        href: 'https://outlook.live.com/mail/0/deeplink/compose?path=%2fmail%2faction%2fcompose&',
        menuItem: 'Outlook',
        subjectParam: 'subject'
    }
];

export default function getMailLinkMenu({to, subject, body, ...props}) {

    return <Menu>
            {clientInfo.map(ci=>
                <Menu.Item key={ci.menuItem}>
                    <a
                        title={ci.title}
                        href={encodeURI(ci.href
                            + (to ? 'to='+ to + '&' : '')
                            + (subject ? ci.subjectParam + '='+ subject + '&' : '')
                            + (body ? 'body='+ body : ''))}
                        target="mail">{ci.menuItem}</a>
                </Menu.Item>
            )}
        </Menu>
    ;
}